import { faCheck, faDownload, faTimes } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Avatar, Box, Grid, List, ListItem, ListItemAvatar, ListItemText, Typography } from "@mui/material"
import PaperBox from "components/PaperBox"
import { UserNameAccronym } from "components/UserNameAccronym"
import { CircleIcon } from "components/icons/CircleIcon"
import theme from "css/theme/light"
import React from "react"
import { CertificateDownloadLink } from "shared/learning/components/CertificateRender"
import { StyledAvatar, StyledBox, StyledSpan, StyledTypography } from "./Summary.styled"
import moment from "moment"
import { useTranslation } from "react-i18next"

export const Summary = (props) => {
  const { item } = props
  const { t } = useTranslation()

  return (
    <React.Fragment>
      <PaperBox marginTop={0}>
        <Grid container direction={"column"} justifyContent="center" alignItems="center">
          <Box mb={2}>
            <Typography variant="caption" color="textSecondary">
              {moment(item.completedDate).format("YYYY-MM-DD")}
            </Typography>
          </Box>
          <StyledTypography variant="h1">
            {item.correctAnswersCount}
            <StyledSpan>/{item.totalQuestionsCount}</StyledSpan>
          </StyledTypography>

          <Box>
            {item.calculatedPassed ? (
              <Grid container direction="row" justifyContent="center" alignItems="center" my={3} spacing={1}>
                <Grid item>
                  <StyledAvatar>
                    <FontAwesomeIcon icon={faCheck} size={"xs"} />
                  </StyledAvatar>
                </Grid>
                <Grid item>
                  <Typography variant="caption">{t("learning.titles.passed", "Passed")}</Typography>
                </Grid>
              </Grid>
            ) : (
              <Grid container direction="row" justifyContent="center" alignItems="center" my={2} spacing={1}>
                <Grid item>
                  <CircleIcon
                    sx={{ width: "40px", height: "40px" }}
                    icon={faTimes}
                    backgroundColor={theme.palette.red[200]}
                    color={theme.palette.red[900]}
                  />
                </Grid>
                <Grid item>
                  <Typography variant="caption">
                    {t("learning.titles.not_approved", "Not approved")}
                  </Typography>
                </Grid>
              </Grid>
            )}
          </Box>
        </Grid>

        {item && item.calculatedPassed && (
          <StyledBox>
            <CertificateDownloadLink item={item}>
              <Grid container direction="row" justifyContent="space-between" alignItems="center">
                <Typography variant="bodyMedium">
                  {t("learning.result.titles.downloadCert", "Download certificate")}
                </Typography>
                <FontAwesomeIcon icon={faDownload} />
              </Grid>
            </CertificateDownloadLink>
          </StyledBox>
        )}
      </PaperBox>
      <PaperBox p={3}>
        <Box display="flex">
          <ListItemAvatar>
            <Avatar sx={{ background: theme.palette.primary["light"], color: theme.palette.primary["dark"] }}>
              <UserNameAccronym name={item.userFullName} />
            </Avatar>
          </ListItemAvatar>
          <Box display="flex" flexDirection="column">
            <Typography variant="bodyMedium" fontWeight="600">
              {item.userFullName}
            </Typography>
            <Typography variant="textSecondary">{item.userEmail}</Typography>
          </Box>
        </Box>
      </PaperBox>
    </React.Fragment>
  )
}
